// LoginForm.tsx
import React from 'react';
import { Button, Checkbox, Input } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import { useTranslation } from 'react-i18next';

interface UserLoginFormProps {
    username: string;
    password: string;
    passwordVisible: boolean;
    rememberMe: boolean;
    setUsername: (username: string) => void;
    setPassword: (password: string) => void;
    togglePasswordVisibility: () => void;
    toggleRememberMe: () => void;
    onLogin: (e: React.FormEvent) => void;
}

const UserLoginForm: React.FC<UserLoginFormProps> = ({ ...props }) => {
    const { t } = useTranslation();
    return (
        <form onSubmit={(e) => props.onLogin(e)}>
            <div className="row-data-input">
                <Input
                    dataType="text"
                    icon="abb/user"
                    label={t(CONSTANTS.LOGIN_USERNAME)}
                    className="username"
                    value={props.username}
                    onValueChange={(val) => props.setUsername(val)}
                />
            </div>
            <div className="row-data-input">
                <Input
                    dataType={props.passwordVisible ? "text" : "password"}
                    icon={props.passwordVisible ? "abb/view" : "abb/hide"}
                    label={t(CONSTANTS.LOGIN_PASSWORD)}
                    className="password"
                    value={props.password}
                    onValueChange={(val) => props.setPassword(val)}
                    onIconClick={(e) => props.togglePasswordVisibility()}
                />
            </div>
            <br />
            <div className="row-data-input">
                <Checkbox
                    label={t(CONSTANTS.REMEMBER_ME_TEXT)}
                    value={props.rememberMe}
                    className="login-checkbox"
                    onChange={(e) => props.toggleRememberMe()}
                />
            </div>
            <br />
            <div className="row-data-input">
                <Button
                    text={t(CONSTANTS.LOGIN_BUTTON)}
                    type="primary-black"
                    onClick={(e) => props.onLogin(e)}
                    shape="rounded"
                />
            </div>
        </form>
    );
};

export default UserLoginForm;